import { Box, HStack, Text, VStack } from "native-base";
import React from "react";
import { FlatList } from "react-native";

import BannerImage from "@/components/atoms/BannerImage";
import RoundedLogo from "@/components/atoms/RoundedLogo";
import MobileHeader from "@/components/molecules/MobileHeader";
import Container from "@/components/organisms/Container";

import PromotionListItemLoading from "./components/PromotionListItemLoading";
import { PromotionListScreenProps } from "./types";

const PromotionListMobile = ({
  promotions,
  isLoading,
  onGoBack,
  onLoadMore,
  onSelectPromotion,
}: PromotionListScreenProps) => {
  return (
    <Container
      px="8"
      pt="2"
      mb="32"
      Header={<MobileHeader title="Promoções" showLogo={true} onBackPress={onGoBack} />}>
      <VStack alignItems="center">
        <FlatList
          data={promotions || new Array(6).fill(null)}
          nestedScrollEnabled
          keyExtractor={(item, index) => (item ? item._id : String(index))}
          showsVerticalScrollIndicator={false}
          onEndReached={onLoadMore}
          onEndReachedThreshold={0.1}
          renderItem={({ item }) =>
            isLoading ? (
              <PromotionListItemLoading />
            ) : (
              <VStack m="2" position="relative">
                <Text fontSize="lg" bold>
                  {item.estabelecimento?.nome_fantasia}
                </Text>
                <HStack space={4} alignItems="center">
                  <Box position="absolute" left={-10} zIndex={999}>
                    <RoundedLogo logoUrl={item.estabelecimento?.foto_estabelecimento} />
                  </Box>
                  <Box bgColor="light.50" shadow={4} rounded="lg">
                    <BannerImage
                      width="280px"
                      imageUrl={item.foto_promocao}
                      onPress={() => onSelectPromotion(item.estabelecimento._id)}
                    />
                  </Box>
                </HStack>
              </VStack>
            )
          }
        />
      </VStack>
    </Container>
  );
};

export default PromotionListMobile;
